import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const outgoingEmailTabStyles = StyleSheet.create({
	section: {
		maxWidth: 640,
	},
	formCard: {
		marginBottom: 16,
	},
	previewCard: {
		padding: '18px 20px',
	},
	previewLabel: {
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.5,
		color: THEME.colors.text.light,
		textTransform: 'uppercase' as const,
		marginBottom: 12,
	},
	previewFrame: {
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 10,
		overflow: 'hidden' as const,
	},
	previewHeader: {
		padding: '11px 14px',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		backgroundColor: THEME.colors.background.main,
	},
	previewFrom: {
		fontSize: 13,
		color: THEME.colors.text.main,
	},
	previewMuted: {
		color: THEME.colors.text.light,
	},
	previewReplyTo: {
		fontSize: 12,
		color: THEME.colors.text.light,
		marginTop: 2,
	},
	previewBody: {
		padding: 14,
		fontSize: 14,
		color: THEME.colors.text.main,
		lineHeight: 1.55,
	},
	previewBodyPlaceholder: {
		color: THEME.colors.text.light,
		fontStyle: 'italic',
		margin: 0,
	},
	previewSigDivider: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
		margin: '12px 0 0',
		paddingTop: 12,
	},
	previewCsat: {
		marginTop: THEME.spacing.md,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	previewCsatLink: {
		color: THEME.colors.primary.main,
		textDecoration: 'underline',
	},
});
